
import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import * as AdmEmpresaActions from '../../../actions/';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import { Store } from '@ngrx/store';
import { empresaService } from 'src/app/services/SiicartAdm/empresaAdm.service';
import { AdmEmpresaActionTypes } from '../../../actions/AdmSiicart/Usuarios/admEmpresa.actions';

@Injectable()
export class admEmpresaEffects {

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private EmpresaService: empresaService,
    private config: ConfigService,
    private router: Router
  ) {}

  // effects go here
    @Effect()
    AdmGetEmpresa$: Observable<any> = this.actions$.pipe(
        ofType(AdmEmpresaActions.AdmEmpresaActionTypes.GET_ADM_EMPRESA),
        switchMap((action: AdmEmpresaActions.AdmGetEmpresa) => {
            return this.EmpresaService.ObtenerEmpresas()
                .pipe(
                    map((resultado: any) => {
                        return new AdmEmpresaActions.AdmSuscesEmpresa(resultado, 'ListEmpresas');
                    }),
                    catchError(error => of (new AdmEmpresaActions.AdmFailEmpresa({ error })))
                );
            }
        )
    );

    
    @Effect()
    AdmSetUsers$: Observable<any> = this.actions$.pipe(
        ofType(AdmEmpresaActions.AdmEmpresaActionTypes.SET_ADM_EMPRESA),
        switchMap((action: AdmEmpresaActions.AdmSetEmpresa) => {
            return this.EmpresaService.AgrModfEmpresa(action.DatosEmpresa)
                .pipe(
                    map((resultado: any) => {
                        return new AdmEmpresaActions.AdmSuscesEmpresa(resultado, 'SetEmpresa');
                    }),
                    catchError(error => of (new AdmEmpresaActions.AdmFailEmpresa({ error })))
                );
            }
        )
    );

    @Effect()
    AdmDeleteUsers$: Observable<any> = this.actions$.pipe(
        ofType(AdmEmpresaActions.AdmEmpresaActionTypes.DELETE_ADM_EMPRESA),
        switchMap((action: AdmEmpresaActions.AdmDeleteEmpresa) => {
            return this.EmpresaService.EliminarEmpresa(action.ObjDel)
                .pipe(
                    map((resultado: any) => {
                        return new AdmEmpresaActions.AdmSuscesEmpresa(resultado, 'DeleteEmpresa');
                    }),
                    catchError(error => of (new AdmEmpresaActions.AdmFailEmpresa({ error })))
                );
            }
        )
    );
}
